import { render, staticRenderFns } from "./Congratulations.vue?vue&type=template&id=3a99ec3d&scoped=true&"
import script from "./Congratulations.vue?vue&type=script&lang=js&"
export * from "./Congratulations.vue?vue&type=script&lang=js&"
import style0 from "./Congratulations.vue?vue&type=style&index=0&id=3a99ec3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a99ec3d",
  null
  
)

export default component.exports